/**
 * Shared welding machine wire values for Upload Weld Data / TLOG / Manual flows.
 * Kept in a leaf module to avoid circular imports between dialog components.
 */
export enum WeldingSystemConfigEnum {
  P600Z = 'p600z',
  M500 = 'm500',
  P625 = 'p625',
  IWM = 'iwm',
}

/** UI-only select value — Manual folder/zip flow (resolves to P600Z for APIs). */
export const MANUAL_MACHINE_SELECT_VALUE = 'manual' as const;

export type WeldDataMachineSelectValue =
  | WeldingSystemConfigEnum
  | typeof MANUAL_MACHINE_SELECT_VALUE;

export const isWeldingSystemConfig = (v: string): v is WeldingSystemConfigEnum =>
  (Object.values(WeldingSystemConfigEnum) as string[]).includes(v);
